/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the StartJobModalForm component.
 */
export const START_JOB_EXECUTIONS_DATA_IDS = {
  cancel: 'Button: Cancel button',
  startJob: 'Button: Start job button',
  startJobError: `Form: Start job form error message`,
};
